// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_q9-5";
export var filledCircle = "_q9-4";
export var historyEntry = "_q9-3";
export var messageSideLeft = "_q9-1";
export var messageSideRight = "_q9-2";
export var orderTrackingCarouselWrapper = "_q9-6";
export var orderTrackingInfoContainer = "_q9-0";